window.bootstrap = require("bootstrap");
import "@/styles/main.scss";
import "@/js/modules/correctVh";
import "@/js/modules/openMenu";
// import "@/js/modules/questions";
import "@/js/modules/animationOnScroll";
import "@/js/modules/lozad";
import "@/js/modules/toc";
import "@/js/modules/advertisingDisclousureInsert";
import "@/js/modules/tooltips";
import "@/js/modules/infoTooltip";
import "@/js/modules/reviewsSlider";
import "@/js/modules/checkSmartBanner";
import "@/js/modules/sidebarNegativeOffset";
import "@/js/modules/contactModal";
import "@/js/modules/redirectToApp";
import "@/js/modules/starsRating";
import "@/js/modules/customSelect";
// import "@/js/modules/communitySlider";
import "@/js/modules/formLoader";
import "@/js/modules/swiperGridPosts";
import "@/js/modules/customHref";
import "@/js/modules/replaceInlineSvg";
// import "@/js/modules/footerDisclaimer";
import "@/js/modules/partnersLoader";
import "@/js/modules/modalAutoAppearing";
import "@/js/modules/preloadIntroImage";
import "@/js/modules/buttonUp";
import "@/js/modules/mobOffsetForAbsoluteHeadings";
import "@/js/modules/pwa_analytics";
import "@/js/modules/postContent";
